import config from 'company-management/config'

const adminApi = `${config.apiHost}/oem-auth`

export default {
    list: {
        url: `${adminApi}/admin/modules`,
        type: 'GET',
    },
    tree: {
        url: `${adminApi}/admin/modules/tree`,
        type: 'GET',
    },
    create: {
        url: `${adminApi}/admin/modules`,
        type: 'POST',
    },
    update: {
        url: `${adminApi}/admin/modules/{id}`,
        type: 'PUT',
    },
    remove: {
        url: `${adminApi}/admin/modules/{id}`,
        type: 'DELETE',
    },
}
